import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const KgDailyLogs = lazy(() => import('../pages/kg/KgDailyLogs'));
const KgMilestones = lazy(() => import('../pages/kg/KgMilestones'));
const KgSafety = lazy(() => import('../pages/kg/KgSafety'));
const KgReportCard = lazy(() => import('../pages/kg/KgReportCard'));

const KgRoutes = () => {
  return (
    <Routes>
      <Route path="daily-logs" element={<KgDailyLogs />} />
      <Route path="milestones" element={<KgMilestones />} />
      <Route path="pickups" element={<KgSafety />} />
      <Route path="reports" element={<KgReportCard />} />
    </Routes>
  );
};

export default KgRoutes;
